import { render, staticRenderFns } from "./ownershipInsights.vue?vue&type=template&id=00d2513c&scoped=true&"
import script from "./ownershipInsights.vue?vue&type=script&lang=js&"
export * from "./ownershipInsights.vue?vue&type=script&lang=js&"
import style0 from "./ownershipInsights.vue?vue&type=style&index=0&id=00d2513c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d2513c",
  null
  
)

export default component.exports